



























































import { defineComponent, ref, computed, watch } from '~/utils/nuxt3-migration'
import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import { facetHandlerComponentProps } from '~/constants/classified/search/facet'
import { useNamespacedStore } from '~/compositions/store'
import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import useClassifiedSearchFacet from '~/compositions/classified-search/useClassifiedSearchFacet'
import { ciGearboxManual } from '~/icons/source/regular/gearbox-manual'
import { ciGearboxAuto } from '~/icons/source/regular/gearbox-auto'
import { ciGearboxSemiAuto } from '~/icons/source/regular/gearbox-semi-auto'
import { ciDriveType4wd } from '~/icons/source/regular/drive-type-4wd'
import { ciDriveTypeRwd } from '~/icons/source/regular/drive-type-rwd'
import { ciDriveTypeFwd } from '~/icons/source/regular/drive-type-fwd'
import { ciOutboardMotor } from '~/icons/source/regular/outboard-motor'
import { ciInboardMotor } from '~/icons/source/regular/inboard-motor'
import { ciWithoutEngine } from '~/icons/source/regular/without-engine'
import CRadioButtonGroup from '~/components/shared/configurable/button/CRadioButtonGroup.vue'
import { useI18n } from '~/compositions/i18n'
import { Searchable } from '~/models/search/types'
import { Option } from '~/models/shared/types'
import { Icon } from '~/models/icons/types'

const buttonsIcons: Record<string, Icon> = {
  automatic: ciGearboxAuto,
  semiauto: ciGearboxSemiAuto,
  manual: ciGearboxManual,
  '4x4': ciDriveType4wd,
  AWD: ciDriveType4wd,
  RWD: ciDriveTypeRwd,
  FWD: ciDriveTypeFwd,
  outboard_motor: ciOutboardMotor,
  inboard_motor: ciInboardMotor,
  without_engine: ciWithoutEngine
}

export default defineComponent({
  props: facetHandlerComponentProps,
  components: {
    CRadioButtonGroup,
    CCustomSelect
  },
  setup(props) {
    const { state: classifiedSearchState } = useNamespacedStore<SearchState>(
      CLASSIFIED_SEARCH_NS
    )
    const { changeParam } = useClassifiedSearchFacet({
      onClearAll: () => {
        if (selectRef.value) {
          selectRef.value.clearSearchInput()
        }
      }
    })
    const { t } = useI18n()

    const singleSelectedValue = ref(
      props.selected && Array.isArray(props.selected) ? props.selected[0] : null
    )
    const multiSelectedValue = ref(props.selected || [])
    const selectRef = ref<typeof CCustomSelect>()

    const loadingFacets = computed(() => classifiedSearchState.loading.facets)

    const options = computed(() =>
      (props.searchables || []).map((s: Searchable) => ({
        label: s.n,
        value: s.v,
        count: s.c,
        disabled: s.c === 0 && !multiSelectedValue.value.includes(s.v)
      }))
    )

    const isSearchable = computed(
      () => props.type === 'VehicleFeaturesSearchHandler'
    )

    const showOptionsAsIconButtons = computed(() =>
      ['gearbox_type', 'drive_type', 'engine_type'].includes(props.name)
    )

    const showOptionsAsButtonGroup = computed(() =>
      ['crashed', 'damaged', 'audit_options', 'seller_type'].includes(
        props.name
      )
    )

    const buttonGroupOptions = computed(() => [
      {
        value: null,
        label: t('all')
      },
      ...options.value
    ])

    watch(
      () => props.selected,
      (newValue: any) => {
        if (newValue && Array.isArray(newValue)) {
          singleSelectedValue.value = newValue[0] || null
          multiSelectedValue.value = newValue
        } else {
          singleSelectedValue.value = null
          multiSelectedValue.value = []
        }
      }
    )

    function onClearButtonClick() {
      singleSelectedValue.value = null
      multiSelectedValue.value = []

      if (selectRef.value) {
        selectRef.value.clearSearchInput()
      }

      changeParam({
        name: props.urlArgNames[0],
        value: null
      })
    }

    function onSelectChange(value: (string | number)[] | string | number) {
      if (Array.isArray(value)) {
        multiSelectedValue.value = value
      } else {
        singleSelectedValue.value = value
      }

      changeParam({
        name: props.urlArgNames[0],
        value
      })
    }

    function getIconButtonIcon(option: Option) {
      return buttonsIcons[option.value as string]
    }

    function iconButtonIsSelected(option: Option) {
      if (props.isMultiselect) {
        return multiSelectedValue.value.includes(option.value)
      }

      return singleSelectedValue.value === option.value
    }

    function onIconButtonClick(option: Option) {
      if (props.isMultiselect) {
        if (multiSelectedValue.value.includes(option.value)) {
          multiSelectedValue.value = multiSelectedValue.value.filter(
            (v: number) => v !== option.value
          )
        } else {
          multiSelectedValue.value.push(option.value)
        }
      } else {
        singleSelectedValue.value = option.value
      }

      changeParam({
        name: props.urlArgNames[0],
        value: props.isMultiselect
          ? multiSelectedValue.value
          : singleSelectedValue.value
      })
    }

    function onButtonGroupChange(value: string | null) {
      changeParam({
        name: props.urlArgNames[0],
        value
      })
    }

    return {
      selectRef,
      loadingFacets,
      singleSelectedValue,
      multiSelectedValue,
      options,
      isSearchable,
      showOptionsAsIconButtons,
      showOptionsAsButtonGroup,
      buttonGroupOptions,
      iconButtonIsSelected,
      onSelectChange,
      onClearButtonClick,
      getIconButtonIcon,
      onIconButtonClick,
      onButtonGroupChange
    }
  }
})
